import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { DialogContent } from '@mui/material';
import TestaPepper from 'assets/images/testa_pepper.png';
import CenteredText from './CenteredText';
import { styled } from '@mui/system';

function SimpleDialog({
  onClose,
  onConfirm,
  onCancel,
  title,
  open,
  children,
  cancelLabel = "Annulla",
  confirmLabel = "Continua",
  headerImage = TestaPepper,
  disableCancel = false,
  disableConfirm = false
}) {

  const handleClose = () => {
    onClose && onClose();
  };

  const handleConfirm = () => {
    onConfirm && onConfirm()
    handleClose();
  }

  const handleCancel = () => {
    onCancel && onCancel()
    handleClose()
  }


  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
      margin: '1rem'
    },
    '& .MuiPaper-rounded': {
      borderRadius: '2rem'
    },
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.white.main,
    },
    '& .MuiTypography-root': {
      color: theme.palette.primary.main
    },
    '& .MuiDialogActions-root': {
      //padding: theme.spacing(1),
    },
  }));

  return (
    <BootstrapDialog onClose={handleClose} open={open}>
      <CenteredText>
        <img src={headerImage} alt="pepper" height="80rem" />
      </CenteredText>
      <DialogContent>
        <CenteredText>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{title}</Typography>
        </CenteredText>
        <CenteredText>
          {children}
        </CenteredText>
        <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between' }}>
          {!disableCancel && <Button variant="outlined" color="primary" onClick={handleCancel}>{cancelLabel}</Button>}
          {!disableConfirm && <Button variant="contained" color="primary" size="small" onClick={handleConfirm}>{confirmLabel}</Button>}
        </div>
      </DialogContent>
    </BootstrapDialog>
  );
}


export default SimpleDialog;